import { useVariant } from '@unleash/proxy-client-react';

import { isTreatmentEnrolled } from 'utils/unleash';

export const useUnleashABTest = (testName: string) => {
  const variant = useVariant(testName);

  const treatmentVariant = {
    name: testName,
    enabled: false,
    ...variant
  };

  const isEnrolled = isTreatmentEnrolled(treatmentVariant);

  return { isEnrolled };
};
